import React from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

import "./headingOne.scss";

const HeadingOne = (props: ReferenciaContenido) => {
  const { tituloGeneral, descripcion } = props;

  return (
    <section className="a-heading-one">
      <h1 className="a-heading-one__title">{tituloGeneral}</h1>
      {descripcion &&
        <p className="a-heading-one__description">
          {descripcion.json.content[0].content[0].value}
        </p>
      }
    </section>
  )
}

export default HeadingOne;